import { Fragment, useState } from 'react';

import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

export default function DebugDialog(props) {
  const { buf2hex, btSend, changeSetting, data, device, properties, propertyNumbers, setPropertyNumbers, sendProperties, rawData } = props

  const [open, setOpen] = useState(false);

  const [ customPropertyChange, setCustomPropertyChange ] = useState(false)
//   console.log("customPropertyChange is", customPropertyChange)

  const [ customOpcodeChange, setCustomOpcodeChange ] = useState(false) 
  console.log("customOpcodeChange is", customOpcodeChange)

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <Button color="white" variant="outlined" onClick={handleClickOpen}>
        Debug
      </Button>
      <Dialog
        fullScreen={fullScreen}
        maxWidth="md"
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Debug
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
            <Stack gap={3}>
                <Stack 
                    direction="row"
                    flexWrap="wrap"
                    gap={1}
                >
                    <Autocomplete
                        freeSolo
                        multiple
                        onChange={(event, newValue) => {
                            let numbers = newValue.map(val => properties.find(property => property.name === val)?.number || parseInt(val))
                            setPropertyNumbers(numbers);
                        }}
                        options={properties.map((property) => property.name)}
                        renderValue={(value, getItemProps) =>
                            value.map((option, index) => {
                                const { key, ...itemProps } = getItemProps({ index });
                                return (
                                <Chip variant="outlined" label={option} key={key} {...itemProps} />
                                );
                            })
                        }
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                label="Query properties"
                                placeholder="Choose from list or enter number"
                            />
                        )}
                        sx={{
                            width: "100%"
                        }}
                        value={propertyNumbers.map(propertyNumber => properties.find(propertyObj => propertyObj.number === propertyNumber)?.name || propertyNumber)}
                    />
                    <Button
                        disabled={! Boolean(device)}
                        onClick={() => {
                            sendProperties()
                        }} 
                        variant="outlined"
                    >
                        Read (0x52)
                    </Button>
                </Stack>
                <Stack
                    component="form"
                    direction="row"
                    flexWrap="wrap"
                    gap={1}
                    noValidate
                    autoComplete="off"
                >
                    <TextField
                        label="Property Number (decimal)"
                        value={customPropertyChange.propertyNumber}
                        onChange={(event) => {
                            setCustomPropertyChange((prevState) => {
                                return {
                                    ...prevState,
                                    propertyNumber: parseInt(event.target.value)
                                }
                            });
                        }}
                        type="number"
                        sx={{
                            flexBasis: "49%",
                            flexGrow: 1
                        }}                
                    />
                    <TextField
                        label="Bytes Count (decimal)"
                        value={customPropertyChange.bytes}
                        onChange={(event) => {
                            setCustomPropertyChange((prevState) => {
                                return {
                                    ...prevState,
                                    bytes: parseInt(event.target.value)
                                }
                            });
                        }}
                        type="number"
                        sx={{
                            flexBasis: "49%",
                            flexGrow: 1
                        }}                
                    />
                    <Autocomplete
                        isOptionEqualToValue={() => false}
                        freeSolo
                        multiple
                        onChange={(event, newValue) => {
                            setCustomPropertyChange((prevState) => {
                                return {
                                    ...prevState,
                                    value: newValue
                                }
                            });
                        }}
                        options={[]}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                label="Value"
                                placeholder="Enter number"
                            />
                        )}
                        sx={{
                            flexBasis: "100%",
                            flexGrow: 1
                        }}
                    />
                    <Button
                        disabled={! (Boolean(device) && customPropertyChange.propertyNumber && customPropertyChange.bytes && customPropertyChange.value)}
                        onClick={() => {
                            changeSetting(customPropertyChange.propertyNumber, customPropertyChange.bytes, customPropertyChange.value)
                        }} 
                        variant="outlined"
                    >
                        Write (0x57)
                    </Button>
                </Stack>
                <Stack
                    component="form"
                    direction="row"
                    flexWrap="wrap"
                    gap={1}
                    noValidate
                    autoComplete="off"
                >
                    <TextField
                        label="Opcode Number (decimal)"
                        value={customOpcodeChange.opcodeNumber}
                        onChange={(event) => {
                            setCustomOpcodeChange((prevState) => {
                                return {
                                    ...prevState,
                                    opcodeNumber: parseInt(event.target.value)
                                }
                            });
                        }}
                        type="number"
                        sx={{
                            flexBasis: "49%",
                            flexGrow: 1
                        }}                
                    />
                    <TextField
                        label="Bytes Count (decimal)"
                        value={customOpcodeChange.bytes}
                        onChange={(event) => {
                            setCustomOpcodeChange((prevState) => {
                                return {
                                    ...prevState,
                                    bytes: parseInt(event.target.value)
                                }
                            });
                        }}
                        type="number"
                        sx={{
                            flexBasis: "49%",
                            flexGrow: 1
                        }}                
                    />
                    <Autocomplete
                        isOptionEqualToValue={() => false}
                        freeSolo
                        multiple
                        onChange={(event, newValue) => {
                            setCustomOpcodeChange((prevState) => {
                                return {
                                    ...prevState,
                                    value: newValue
                                }
                            });
                        }}
                        options={[]}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                label="Value"
                                placeholder="Enter number"
                            />
                        )}
                        sx={{
                            flexBasis: "100%",
                            flexGrow: 1
                        }}
                    />
                    <Button
                        disabled={! Boolean(device) || ! customOpcodeChange.opcodeNumber || isNaN(customOpcodeChange.bytes)}
                        onClick={() => {
                            btSend(customOpcodeChange.opcodeNumber, customOpcodeChange.bytes, customOpcodeChange.value)
                        }} 
                        variant="outlined"
                    >
                        Set (0x5a)
                    </Button>
                </Stack>
                <Box 
                    sx={{
                        backgroundColor: "#141414",
                        color: "#fff",
                        borderRadius: 1,
                        height: 600,
                        overflow: "auto",
                        padding: 2,
                    }}
                >
                    <Typography component="pre" fontFamily="revert">raw data is {JSON.stringify(rawData)}</Typography>
                    <Typography component="pre" fontFamily="revert">hex raw data is {JSON.stringify(buf2hex((new Uint8Array(rawData)).buffer))}</Typography>

                    {
                        Object.keys(data).map(key => 
                            <Typography component="pre" fontFamily="revert">{key}: {JSON.stringify(data[key])}</Typography>
                        )
                    }
                    
                </Box>
            </Stack>
        </DialogContent>
      </Dialog>
    </Fragment>
  );
}